module.exports = __webpack_public_path__ + "img/59.a1057635.jpg";